"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["mx", "px", "width"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ContainerBase = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "container__ContainerBase",
  componentId: "sc-12vgjt-0"
})(["max-width:", "px;"], function (_ref) {
  var maxWidth = _ref.maxWidth;
  return maxWidth || 1200;
});
var propTypes = {
  mx: _utils.stylePropType,
  px: _utils.stylePropType,
  width: _utils.stylePropType
};
/**
 * Container is a Flex component with a max-width set and margin left/right set
 * to auto. This is the standard content max-width used throughout the site.
 * Defaults padding left & right to [1, 2]. Accepts all [Flex]() props.
 */

var Container = function Container(_ref2) {
  var _ref2$mx = _ref2.mx,
      mx = _ref2$mx === void 0 ? "auto" : _ref2$mx,
      _ref2$px = _ref2.px,
      px = _ref2$px === void 0 ? [1, 2] : _ref2$px,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 1 : _ref2$width,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/_react["default"].createElement(ContainerBase, _extends({
    mx: mx,
    px: px,
    width: width
  }, props));
};

Container.propTypes = propTypes;
var _default = Container;
exports["default"] = _default;